export const state = () => ({
  items_count: 0,
  pages_count: 0,
  results: []
})

export const getters = {}

export const mutations = {
  setState(state, payload) {
    Object.keys(payload).forEach((item) => {
      if (item in state) {
        state[item] = payload[item]
      }
    })
  }
}

export const actions = {
  fetchSortByDate({ commit }, params) {
    return this.$api
      .get("/user/authors/statistics", {
        params
      })
      .then((res) => {
        if (res) {
          commit("setState", (res && res.data) || {})
        }
      })
      .catch((err) => {
        console.error(err)
        return
      })
  }
}
